export default "__VITE_ASSET__59680ed6__"